import { render, staticRenderFns } from "./rosters-pages.vue?vue&type=template&id=3ecba9e2&scoped=true&"
import script from "./rosters-pages.ts?vue&type=script&lang=ts&"
export * from "./rosters-pages.ts?vue&type=script&lang=ts&"
import style0 from "./rosters-pages.scss?vue&type=style&index=0&id=3ecba9e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecba9e2",
  null
  
)

export default component.exports